
          export const options = {
  "includeNodeModules": false,
  "options": {},
  "clients": {
    "default": {
      "endpoint": "https://graphql.benchmarkminerals.com",
      "options": {
        "requireCredentials": false
      }
    },
    "authenticatedClient": {
      "endpoint": "https://wp-admin.benchmarkminerals.com/wp/graphql",
      "options": {
        "requireCredentials": true
      }
    }
  }
}
        